var map = {
	"./Bilder/Aktuelles/1_Platz_PH2_Winter2024.jpg": 510,
	"./Bilder/Aktuelles/3 Platz Rglt Hambach.jpg": 586,
	"./Bilder/Aktuelles/A Mannschaft VR2024.jpg": 958,
	"./Bilder/Aktuelles/Krebs30032025.jpg": 626,
	"./Bilder/Aktuelles/MeisterVRHerbst2024.jpg": 747,
	"./Bilder/BildTurnhalle.jpeg": 732,
	"./Bilder/Fahne.png": 822,
	"./Bilder/Logo.png": 986,
	"./Bilder/Logo_alt.png": 373,
	"./Bilder/Open1.jpg": 400,
	"./Bilder/Open2.jpg": 331,
	"./Bilder/Open3.jpg": 809,
	"./Bilder/Open4.jpg": 64,
	"./Bilder/Rueckblick/Jugend_Werntalcup_2023.jpg": 306,
	"./Bilder/Rueckblick/Rueckblick1.jpg": 533,
	"./Bilder/Rueckblick/Rueckblick2.jpg": 952,
	"./Bilder/Rueckblick/Rueckblick3.jpg": 410,
	"./Bilder/Rueckblick/Rueckblick4.jpg": 368,
	"./Bilder/Rueckblick/RückblickTTLangendorf.jpg": 588,
	"./Bilder/Rueckblick/Spielstandam07102023.jpg": 152,
	"./Bilder/Rueckblick/TTBLKönigshofen 25112023.jpg": 824,
	"./Bilder/TSVPoppenhausenLogo.jpeg": 820,
	"./Bilder/TSVWappenkd.jpg": 1,
	"./Bilder/tt_banner_header_new.png": 413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;